import { render, staticRenderFns } from "./AdministrarDocumentos.vue?vue&type=template&id=f817427c&scoped=true&"
import script from "./AdministrarDocumentos.vue?vue&type=script&lang=js&"
export * from "./AdministrarDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./AdministrarDocumentos.vue?vue&type=style&index=0&id=f817427c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f817427c",
  null
  
)

export default component.exports